import React from 'react'
import { Button, Modal } from 'react-bootstrap'
import { baseUrl, getInitialRoute } from '../../../../../utils'
import { useDispatch } from 'react-redux'
import { togglePlanSection } from '../../../../../actions/show_modal_Action'
import { togglePlanSection_D } from '../../../../../actions/showDisplayModalAction'

function FeedLimitUpgrade({ closeFeedLimitUpgrade }) {
    const dispatch = useDispatch();
    return (
        <Modal
            size="lg"
            dialogClassName=" modal-dialog-centered modal-dialog"
            show={true}
            onHide={() => closeFeedLimitUpgrade()}
        >
            <Modal.Header closeButton className="border-0 pb-0"></Modal.Header>
            <Modal.Body>
                <div className="row py-5">
                    <div className="col-lg-12">
                        <div className="upgredeMain text-center">
                            <div className="Errorimage pb-3"><img src={baseUrl(`error/add-social-feed.png`)} className="img-fluid" width={500} height={300} /></div>
                            <div className="permissionMsg my-4 px-4">
                                <h4 className="ErrorMsg">Add More Social Feeds</h4>
                                <p className="msgSec">Oops! Looks like you have reached your feed limit. Now add more feeds without upgrading your entire plan and curate exciting widgets with diverse content.</p>
                            </div>
                            <div className="buttonUpgred mb-3">
                                <Button variant='primary' id="addonFeaturesScroll" onClick={() => { getInitialRoute() === 'widget' ? dispatch(togglePlanSection(true)) : dispatch(togglePlanSection_D(true)) }} className="commanBtn px-5" data-factors-click-bind="true">
                                    Upgrade Now
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default FeedLimitUpgrade